"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextLink = exports.TouchLink = exports.TextWithLinks = void 0;
const react_1 = __importDefault(require("react"));
const S = __importStar(require("./TextWithLinks.styles"));
exports.TextWithLinks = ({ children }) => (react_1.default.createElement(S.TextWithLinks, null, children));
exports.TouchLink = ({ children, ...props }) => {
    return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    react_1.default.createElement(S.Link, Object.assign({ testID: "TouchLink" }, props), children));
};
exports.TextLink = ({ children }) => (react_1.default.createElement(S.TextLink, null, children));
